import { gql, TypedDocumentNode } from "@apollo/client";
import type { FacilityOperatingStatus, FacilityType } from "@/types";

export type FacilitiesProcessMergeInput = {
  sourceFacilityId: string;
  targetFacilityId: string;
  sectionId?: string | null;
  mainAddressId?: string | null;
  mailingAddressId?: string | null;
  chapterId?: string | null;
  facilityType?: FacilityType | null;
  operatingStatus?: FacilityOperatingStatus | null;
  phone?: string | null;
  phoneExtension?: string | null;
  website?: string | null;
  parentCompanyId?: string | null;
  managementGroup?: string | null;
};

export type FacilitiesProcessMergeResponse = {
  facilitiesProcessMerge: {
    success: boolean;
    message: string;
  };
};

export const FACILITIES_PROCESS_MERGE_MUTATION: TypedDocumentNode<
  FacilitiesProcessMergeResponse,
  { input: FacilitiesProcessMergeInput }
> = gql`
  mutation FacilitiesProcessMerge($input: FacilitiesProcessMergeInput!) {
    facilitiesProcessMerge(input: $input) {
      success
      message
    }
  }
`;

export type FacilitiesProcessPurgeResponse = {
  facilitiesProcessPurge: {
    success: boolean;
    message: string;
  };
};

export const FACILITIES_PROCESS_PURGE_MUTATION: TypedDocumentNode<
  FacilitiesProcessPurgeResponse,
  { sourceFacilityId: string }
> = gql`
  mutation FacilitiesProcessPurge($sourceFacilityId: ID!) {
    facilitiesProcessPurge(sourceFacilityId: $sourceFacilityId) {
      success
      message
    }
  }
`;
